import { useEffect, useState } from "react";
import axios from "../../api/axios";
import SidebarAdmin from "../../components/SidebarAdmin";
import { formatLocalDate, formatLocalTime } from "../../utils/dateTime";

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get("/admin/activity-logs");
        setLogs(res.data);
      } catch (err) {
        console.error("Failed to fetch logs:", err);
      }
      setLoading(false);
    };
    fetchLogs();
  }, []);

  const getActionColor = (action) => {
    if (action.includes("LOGIN")) return "bg-blue-100 text-blue-700";
    if (action.includes("CREATE") || action.includes("ADD")) return "bg-green-100 text-green-700";
    if (action.includes("DELETE") || action.includes("REVOKE")) return "bg-red-100 text-red-700";
    if (action.includes("UPDATE") || action.includes("MODIFY")) return "bg-yellow-100 text-yellow-700";
    return "bg-gray-100 text-gray-700";
  };

  const getActionIcon = (action) => {
    if (action.includes("LOGIN")) return "🔐";
    if (action.includes("MESSAGE")) return "💬";
    if (action.includes("WHATSAPP")) return "📱";
    if (action.includes("PLAN")) return "💎";
    if (action.includes("USER")) return "👤";
    if (action.includes("PAYMENT")) return "💰";
    return "📋";
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-50">
      <SidebarAdmin />
      <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto mt-14 lg:mt-0">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">Activity Logs</h1>
          <p className="text-gray-500 mt-1">System audit trail - who did what, when</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            {logs.length === 0 ? (
              <div className="p-12 text-center text-gray-400">
                <div className="text-4xl mb-4">📋</div>
                <p>No activity logs yet</p>
                <p className="text-sm mt-2">Actions will be recorded here</p>
              </div>
            ) : (
              <div className="divide-y divide-gray-100">
                {logs.map((log) => (
                  <div key={log.id} className="p-4 hover:bg-gray-50 transition flex items-start gap-4">
                    <div className="text-2xl">{getActionIcon(log.action)}</div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className={`px-2 py-0.5 rounded text-xs font-bold ${getActionColor(log.action)}`}>
                          {log.action}
                        </span>
                        {log.user_name && (
                          <span className="text-sm text-gray-600">
                            by <span className="font-bold">{log.user_name}</span>
                          </span>
                        )}
                      </div>
                      {log.details && (
                        <p className="text-sm text-gray-500">{log.details}</p>
                      )}
                      {log.ip_address && (
                        <p className="text-xs text-gray-400 mt-1">IP: {log.ip_address}</p>
                      )}
                    </div>
                    <div className="text-right text-xs text-gray-400">
                      <p>{formatLocalDate(log.created_at)}</p>
                      <p>{formatLocalTime(log.created_at)}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
